import { render, staticRenderFns } from "./SubFactorQuestion.vue?vue&type=template&id=46c2b3b0&scoped=true"
import script from "./SubFactorQuestion.vue?vue&type=script&lang=js"
export * from "./SubFactorQuestion.vue?vue&type=script&lang=js"
import style0 from "./evaluationTheme.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./SubFactorQuestion.vue?vue&type=style&index=1&id=46c2b3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c2b3b0",
  null
  
)

export default component.exports